import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
import { pwa } from '@/config';
import { useHead } from '@vueuse/head';
import { enLocale, zhLocale } from '@/i18n';

import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { computed, defineAsyncComponent, reactive, watchEffect } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const {
      locale: language
    } = useI18n();
    const locale = computed(() => language.value === 'en' ? enLocale : zhLocale);
    const VabUpdate = defineAsyncComponent(() => import('@/plugins/VabUpdate/index.vue'));
    const siteData = reactive({
      description: ''
    });
    watchEffect(() => {
      siteData.description = `${'Vue'} ${'LianChang'} ${'Plus'}-${route.meta.title} - 畅牛云`;
    });
    useHead({
      meta: [{
        name: `description`,
        content: computed(() => siteData.description)
      }]
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        button: {
          autoInsertSpace: true
        },
        locale: _unref(locale)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, null, {
          default: _withCtx(({
            Component
          }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
          _: 1
        }), _unref(pwa) ? (_openBlock(), _createBlock(_unref(VabUpdate), {
          key: 0,
          ref: "vabUpdateRef"
        }, null, 512)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});